"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUserProfile = exports.loginGetUserProfile = exports.loginByOneClub = void 0;

var _index = _interopRequireDefault(require("../index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// import { checkNaniLinkLogin } from "services/oneClub";

/**
 * 取得登錄資料
 */
var loginByOneClub = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var url, jwt, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = _ref.url, jwt = _ref.jwt;
            _context.next = 3;
            return _index.default.get("".concat(url, "/api/Login"), {}, {
              headers: {
                Authorization: jwt || null
              }
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function loginByOneClub(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.loginByOneClub = loginByOneClub;

var loginGetUserProfile = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3) {
    var url, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = _ref3.url;
            _context2.next = 3;
            return _index.default.get("".concat(url, "/api/Member/Profile"));

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function loginGetUserProfile(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

exports.loginGetUserProfile = loginGetUserProfile;

var setUserProfile = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref5) {
    var url, payload, response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = _ref5.url, payload = _ref5.payload;
            _context3.next = 3;
            return _index.default.post("".concat(url, "/api/Member/Profile"), payload);

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function setUserProfile(_x3) {
    return _ref6.apply(this, arguments);
  };
}();

exports.setUserProfile = setUserProfile;